<template>
  <div class="services-tab-content">
    <div class="services-tab-content__header">
      <BaseButton
        :text="showForm ? 'Lukk skjema' : 'Legg til serviceoppføring'"
        variant="secondary"
        shape="rectangle"
        size="md"
        @click="$emit('toggle-form')"
      />
    </div>
    <ServicesForm
      v-if="showForm"
      v-bind="formProps"
      @hide="$emit('hide-form')"
      @new-service-record="$emit('new-service-record')"
      @update-service-record="$emit('update-service-record')"
    />
  </div>
</template>

<script setup lang="ts">
import BaseButton from "@/components/Base/BaseButton/BaseButton.vue";
import ServicesForm from "../ServicesForm.vue";
import type { ServiceRecord } from "@/types/service-records";

interface Props {
  showForm: boolean;
  formProps: {
    serviceOfferId: number;
    tenderId: number;
    customerOrgNumber: string;
    supplierId: number;
    editingRecord?: ServiceRecord | null;
  };
}

interface Emits {
  (e: "toggle-form"): void;
  (e: "hide-form"): void;
  (e: "new-service-record"): void;
  (e: "update-service-record"): void;
}

defineProps<Props>();
defineEmits<Emits>();
</script>

<style lang="scss" scoped>
.services-tab-content {
  width: 100%;

  &__header {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1rem;

    @media (max-width: $bp-sm) {
      justify-content: start;
    }
  }
}
</style>
